// extracted by css-extract-rspack-plugin
export default {"link":"_7dce63c9","imageWrapper":"_a6a4417d","image":"_51a39d0e"};